import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { CREDIT_CARD_CREDIT_SCORE_LIST, PublicClassNames } from 'embed/constants'

// Filters
import { CardPurposesFilter } from 'embed/components/filters/CardPurposes'
import { CreditScoreFilter } from 'embed/components/filters/CreditScore'

import { Filter, Filters } from 'even-ts-static'
import { useTheme } from 'embed/hooks'
const formStyles = require('embed/components/Form/styles.scss')
const filterStyles = require('embed/styles/filters')

export interface Props {
  filters?: Filters
  onChange: (fieldName: Filter, value, isValid?: boolean) => void
}

const DropdownStyles = {
  dropDown: filterStyles.field,
  dropDownLabel: filterStyles.label,
  fieldError: formStyles.fieldError,
}

export const CreditFilter: React.FC<Props> = ({ filters, onChange }) => {
  const { borderRadiusLarge, backdropStyles, boxStyles, colorBorder } = useTheme()

  return (
    <div
      className={classnames(
        PublicClassNames.FilterContainer,
        filterStyles.filtersWrapper,
        css`
          background-color: ${backdropStyles.backgroundColor};
          border-color: ${colorBorder};
          border-radius: ${borderRadiusLarge};
        `,
      )}
      style={boxStyles}
    >
      <CreditScoreFilter
        containerClass={classnames(PublicClassNames.FormDropdown, filterStyles.container, filterStyles.fiftyFifty)}
        dropdownOptions={CREDIT_CARD_CREDIT_SCORE_LIST}
        onChange={onChange}
        startingValue={filters?.providedCreditRating}
        styles={DropdownStyles}
      />
      <CardPurposesFilter
        containerClass={classnames(PublicClassNames.FormDropdown, filterStyles.container, filterStyles.fiftyFifty)}
        onChange={onChange}
        startingValue={filters?.cardPurposes}
        styles={DropdownStyles}
      />
    </div>
  )
}
